interface HeaderConfig {
  field: string;
  label: string;
  sortable: boolean;
  toggleable: boolean; // Can be hidden/shown via column visibility dropdown
  parentClassName: string;
  alignment?: "left" | "center";
}

export const headerConfig: HeaderConfig[] = [
  {
    field: "specificationName",
    label: "Şartname Adı",
    sortable: false,
    toggleable: false,
    parentClassName: "flex items-center h-12 pl-[45px] pr-3 text-left",
    alignment: "left",
  },
  {
    field: "products",
    label: "Ürünler",
    sortable: false,
    toggleable: false,
    parentClassName: "flex items-center h-12 px-2 text-left",
    alignment: "left",
  },
  {
    field: "itemCount",
    label: "Madde Sayısı",
    sortable: false,
    toggleable: false,
    parentClassName: "flex items-center h-12 justify-center px-2",
    alignment: "center",
  },
  {
    field: "answered",
    label: "Cevaplayan",
    sortable: true,
    toggleable: false,
    parentClassName: "flex items-center h-12 justify-center px-2",
    alignment: "center",
  },
  {
    field: "notAnswered",
    label: "Cevaplamayan",
    sortable: true,
    toggleable: true,
    parentClassName: "flex items-center h-12 justify-center px-2",
    alignment: "center",
  },
  {
    field: "itemStatus",
    label: "Madde Durumu",
    sortable: false,
    toggleable: true,
    parentClassName: "flex items-center h-12 justify-center px-2",
    alignment: "center",
  },
  {
    field: "status",
    label: "Durum",
    sortable: true,
    toggleable: true,
    parentClassName: "flex items-center h-12 justify-center px-2",
    alignment: "center",
  },
];
